import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PhotoSelect from '../../PhotoSelect/PhotoSelect';
import Modal from '../../Modal/Modal';
import styles from './UploadUserPhotoModal.module.scss';
import { PROFILE_AVATARS } from '../../PhotoSelect/PhotoSelectData';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../store/reducers';
import { setUserAvatar } from '../../../store/reducers/App/appSlice';
const UploadUserPhotoModal = ({ isOpen, forwardRef, closeModal }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const handleSave = (filename) => {
        dispatch(setUserAvatar(filename));
        closeModal();
    };
    return (_jsx(Modal, Object.assign({ className: styles.element, closeModal: closeModal }, { children: _jsx(PhotoSelect, { isOpen: isOpen, forwardRef: forwardRef, title: t('select_a_user_profile_picture'), type: "profile", showSaveButton: false, collections: PROFILE_AVATARS, backHandler: closeModal, saveHandler: handleSave }) })));
};
export default UploadUserPhotoModal;
